import React from 'react';

const FoodGrid = ({ onFoodSelect, foodHistory, foods = [], foodsLoading = false, location = '' }) => {
    const recentNames = [...new Set((foodHistory || []).map(h => h.foodName))].slice(0, 4);
    const recentFoods = recentNames.map(name => foods.find(f => f.name === name)).filter(Boolean);
    const otherFoods = foods.filter(f => !recentNames.includes(f.name));
    const displayFoods = [...recentFoods, ...otherFoods];

    const locLabel = location.trim();
    const headline = foodsLoading
        ? `finding popular foods near ${locLabel || 'you'}...`
        : locLabel
            ? `popular near ${locLabel}`
            : 'what are you craving?';

    return (
        <div>
            {recentFoods.length > 0 && (
                <p className="text-xs text-gray-400 mb-2 mt-4">recently searched</p>
            )}
            <div className="flex items-center gap-2 mb-3 mt-4">
                <p className={`text-xs ${foodsLoading ? 'text-orange-400 animate-pulse' : 'text-gray-400'}`}>
                    {headline}
                </p>
            </div>
            <div className="grid grid-cols-4 sm:grid-cols-6 gap-2">
                {displayFoods.map(food => (
                    <button key={food.id} onClick={() => onFoodSelect(food)} className="Food_Card">
                        <span className="text-2xl">{food.emoji}</span>
                        <span className="text-xs mt-1 leading-tight text-center">{food.name}</span>
                    </button>
                ))}
            </div>
        </div>
    );
};

export default FoodGrid;
